export class Region {
  id: number;
  name: string;
  fileName: string;
}
